// Comparison is observational only: no approval inheritance or revision writes.
export function compareAssetManifests(before, after) {
  const index = manifest => {
    if (manifest?.schema !== 'AssetManifest.v1' || !Array.isArray(manifest.files)) throw Error('Revision asset manifest is unavailable.');
    const rows = new Map();
    for (const row of manifest.files) {
      if (!row || typeof row.name !== 'string' || !row.name || rows.has(row.name)
        || !/^[a-f0-9]{64}$/.test(row.sha256) || !Number.isSafeInteger(row.bytes) || row.bytes < 0) {
        throw Error('Revision asset manifest is invalid.');
      }
      rows.set(row.name, row);
    }
    return rows;
  };
  const left = index(before), right = index(after);
  return [...new Set([...left.keys(), ...right.keys()])].sort().map(name => {
    const previous = left.get(name), next = right.get(name);
    return { name, before: previous || null, after: next || null,
      change: !previous ? 'added' : !next ? 'removed'
        : previous.sha256 !== next.sha256 || previous.bytes !== next.bytes ? 'changed' : 'unchanged' };
  });
}
